import { useEffect, useSyncExternalStore } from "react";
import api from "@/lib/api";
import { intlPhone } from "@/lib/contactLinks";

/** iter398 A2 — indice WhatsApp partagé par numéro (module entier) : cache mémoire + question « Ce numéro a-t-il WhatsApp ? » après le 1er clic. */
let hints = {}; // phone → { has, by_name, at } | null (vérifié absent) | undefined (inconnu)
let asking = null; // numéro en attente de réponse
const subs = new Set();
const emit = () => subs.forEach((f) => f());
const pending = new Set();

export const normWa = (p) => intlPhone(p);
export const primeWaHints = (map) => { if (!map) return; hints = { ...hints, ...Object.fromEntries(Object.keys(map).map((k) => [k, map[k]])) }; emit(); };
export const waHint = (phone) => hints[normWa(phone)];

export async function fetchWaHints(phones) {
  const miss = [...new Set(phones.map(normWa).filter((p) => p && hints[p] === undefined && !pending.has(p)))];
  if (!miss.length) return;
  miss.forEach((p) => pending.add(p));
  try {
    const { data } = await api.get("/crm/whatsapp-hints", { params: { phones: miss.join(",") } });
    hints = { ...hints, ...Object.fromEntries(miss.map((p) => [p, data[p] || null])) };
    emit();
  } catch { /* indice indisponible : reste « non vérifié » */ } finally { miss.forEach((p) => pending.delete(p)); }
}

export async function setWaHint(phone, has) {
  const p = normWa(phone);
  const { data } = await api.put(`/crm/whatsapp-hints/${encodeURIComponent(p)}`, { has_whatsapp: has });
  hints = { ...hints, [p]: data.hint };
  emit();
  return data.hint;
}

export const askWa = (phone) => { asking = normWa(phone); emit(); };
export const closeAsk = () => { asking = null; emit(); };
export const getAsking = () => asking;

export function useWaStore() { return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => hints); }
export function useWaAsking() { return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => asking); }
/** Indice d'un numéro : `undefined` inconnu (chargement demandé), `null` non vérifié, `{has:true|false}` renseigné. */
export function useWaHint(phone) {
  const all = useWaStore();
  const p = normWa(phone);
  const h = p ? all[p] : null;
  useEffect(() => { if (p && h === undefined) fetchWaHints([p]); }, [p, h]);
  return h;
}

/** Ouvre WhatsApp Desktop ; si le numéro n'est pas encore vérifié, la question est posée au retour dans Le Desk. */
export function openWhatsapp(phone, href) {
  const p = normWa(phone);
  const h = hints[p];
  window.location.href = href;
  if (h == null) {
    let done = false;
    const ask = () => { if (done) return; done = true; window.removeEventListener("focus", ask); askWa(p); };
    window.addEventListener("focus", ask);
    setTimeout(ask, 1500);
  }
}
